export const qualityConstants = {
  bad: 'bad',
  good: 'good',
  excellent: 'excellent',
};